
import React, { useState, useEffect } from 'react';
import { Tab, TabBody, TabBar, TabBarItem, Toast, Popup } from 'react-weui';

import { getVzanDetail } from '@/services/vzan';
import { postMemberShareLog } from '@/services/myself';

export default ({ match: { params: { type, share_id, id } } }) => {

  useEffect(() => {

      postMemberShareLog({
        courseId: id,
        shareMemberId: share_id,
      }).then(res => {
        if (res && res.code === 200) {
        } else {
          // console.error(res);
        }
      }).finally(() => {
        getVzanDetail({
          type: type,
          id: id,
        }).then(res => {
          if (res.code === 200) {
            // window.alert(res.data.watchUrl);
            location.href = res.data.watchUrl;
          }
        }).finally(() => {});
      });

  }, []);

  return (
    <div style={{width: '100vw', height: '100vh'}}>
      <Toast icon="loading" show={true} >加载中...</Toast>
    </div>
  )
}
